export const CHANNEL_GET_MY_DETAILS = "CHANNEL_GET_MY_DETAILS";
export const CHANNEL_GET_MY_VIDEOS = "CHANNEL_GET_MY_VIDEOS";
export const CHANNEL_UPDATE_DETAILS = "CHANNEL_UPDATE_DETAILS";
export const CHANNEL_ADD_VIDEO = "CHANNEL_ADD_VIDEO";
export const CHANNEL_UPDATE_VIDEO = "CHANNEL_UPDATE_VIDEO";
export const CHANNEL_DELETE_VIDEO = "CHANNEL_DELETE_VIDEO";
export const CHANNEL_GET_VIDEO_DETAILS = "CHANNEL_GET_VIDEO_DETAILS";

export const CHANNEL_GET_ALL = "CHANNEL_GET_ALL";
export const CHANNEL_GET_ALL_EVENTS = "CHANNEL_GET_ALL_EVENTS";
export const CHANNEL_SET_EVENT_AS_SPONSORED = "CHANNEL_SET_EVENT_AS_SPONSORED";

export const CHANNEL_GET_ALL_VOTING_SESSIONS = "CHANNEL_GET_ALL_VOTING_SESSIONS";
export const CHANNEL_RECALCULATE_VOTING_TRANSACTIONS = "CHANNEL_RECALCULATE_VOTING_TRANSACTIONS";
export const CHANNEL_SET_ITEM_AS_SPONSORED = "CHANNEL_SET_ITEM_AS_SPONSORED";

export const CHANNEL_GET_ALL_VIDEOS = "CHANNEL_GET_ALL_VIDEOS";
